import * as React from 'react';


export default class Nfbell extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 12 12" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" fillRule="evenodd" stroke="#FFF">
            <path d="M7.708 9.664a1.397 1.397 0 1 1-2.794 0M9.944 7.095V4.81c0-1.99-1.533-3.723-3.52-3.783a3.632 3.632 0 0 0-3.745 3.63v2.438a.375.375 0 0 1-.375.375.53.53 0 0 0-.529.53v.034c0 .292.237.53.53.53h8.014a.53.53 0 0 0 .529-.53V8a.53.53 0 0 0-.53-.53.375.375 0 0 1-.374-.374z"/>
        </g>
      </svg>
    )
  }
}
